// extracted by mini-css-extract-plugin
export var circle = "_bi-1";
export var exitConfirmationModal = "_bi-5";
export var iframe = "_bi-0";
export var offline = "_bi-3";
export var online = "_bi-2";
export var workstationSelectError = "_bi-4";